import React from "react";
import { useSelector } from "react-redux";
import CompetitionLogo from "../../ui/icons/competitionLogo/CompetitionLogo";
import logo from "../../../assets/header/logo.png";
import logoMobile from "../../../assets/header/stemLogoMobile.png";
import skillzLogo from "../../../assets/header/skillzLogo.png";
import ContestTabs from "../../Layout/ContestTabs/ContestTabs";
import classes from "./Header.module.css";

const Header = () => {

  const { texts } = useSelector(state => state.translate);

  return (
    <header className={classes.header} dir="rtl">
      <div className={classes.headerTopBar}>
        <div className={classes.contestTabsContainer}>
          <ContestTabs />
        </div>
        <div className={classes.skillzBlock}>
          <div className={classes.skillzBlockItems}>
            <img src={skillzLogo} alt="SkillZ" className={classes.skillzLogo} />
            <div className={classes.stemText}>
              <div>{texts?.champions}</div>
              <div>{texts?.year}</div>
            </div>
          </div>
          <img src={logo} alt="STEM" className={classes.stemLogo} />
          <img src={logoMobile} alt="STEM" className={classes.stemLogoMobile} />
        </div>
        {/* <CompetitionLogo width="153.36px" height="42.514px" className={classes.competitionLogoMobile} /> */}
      </div>
    </header>
  );
};

export default Header;
